import React from 'react';
import moment from 'moment';
import { isBoolean } from 'lodash';
import CustomDatePicker from '../Utility/DatePicker/DatePicker';
import 'react-datepicker/dist/react-datepicker.css';

export function DatePickerElement(props) {
  const { placeHolder, rowIndex, colIndex, onChange, CustomAddEditAccess, gridY, range, value, handleCalendarOpen, handleCalendarClose } = props;
  return (
    <div className="dt_picker position-relative mb-0">
      <CustomDatePicker
        dateFormat={range ? 'dd-MMM-yy' : 'dd-MMM-yyyy'}
        popperPlace={gridY > 30 ? 'top' : 'bottom'}
        name="selectedDate"
        disable={isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false}
        placeholder={placeHolder}
        valueProp={value}
        onChange={(e) => onChange(range ? e : moment(new Date(e)).format('DD-MMM-YYYY'), rowIndex, colIndex)}
        isRange={range}
        startDate={Array.isArray(value) ? value?.[0] : null}
        endDate={Array.isArray(value) ? value?.[1] : null}
        onCalendarClose={handleCalendarClose}
        onCalendarOpen={handleCalendarOpen}
      />
    </div>
  );
}
export default DatePickerElement;
